// @ts-nocheck
import { VOTE_ERROR, VOTE_LOADING, VOTE_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const vote = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: VOTE_LOADING,
                data: true
            })
            Authservices.vote(data).then((data) => {
                if (data?.status === 200) {
                    dispatch({
                        type: VOTE_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    dispatch({
                        type: VOTE_ERROR,
                        data: {message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'}
                    })
                }
                return reject({message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'})
            })
        })
    }
}